export default __webpack_public_path__ + "static/media/6bb919cd3287ad03e6221329a553f15e.svg";